import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {MatCalendar} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../../../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../../../../shared/services/util.service';

@Component({
  selector: 'app-calendar-header',
  templateUrl: './calendar-header.component.html',
  styleUrls: ['./calendar-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarHeaderComponent<D> implements OnInit, OnDestroy {
  private destroyed = new Subject<void>();
  @Input() minDate1; // = '2020-07-20';
  @Input() maxDate1; // = '2020-09-24';
  // enablePrev: boolean;
  enableNext: boolean;
  previousbuttondisabled:boolean=false;
  today=new Date();
  private subs: SubscriptionList = {};

  constructor(
    private readonly translate : TranslateService,
    private calendar: MatCalendar<D>, private dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private dateFormats: MatDateFormats, cdr: ChangeDetectorRef) {
    this.subs.statechange = calendar.stateChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe(() => cdr.markForCheck());
  }

  ngOnInit(): void {
    this.enableDisablePrevNextButtons();
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
    this.destroyed.next();
    this.destroyed.complete();
  }

  get periodLabel() {
    if(this.dateAdapter.isValid(this.calendar.activeDate)){
      const month = this.dateAdapter.format(this.calendar.activeDate, 'MMMM');
      const year = this.dateAdapter.format(this.calendar.activeDate, 'yyyy');
      return `${this.translate.instant(`common.${month}`)} ${year}`;
    }
    return '';
  }

  previousClicked(mode: 'month' | 'year') {
    if(mode==='month' && (this.today.getMonth())===this.dateAdapter.getMonth(this.calendar.activeDate)
    && (this.today.getFullYear())===this.dateAdapter.getYear(this.calendar.activeDate))
    {
      this.enableDisablePrevNextButtons();
    }
    else{
    this.calendar.activeDate = mode === 'month' ?
      this.dateAdapter.addCalendarMonths(this.calendar.activeDate, -1) :
      this.dateAdapter.addCalendarYears(this.calendar.activeDate, -1);
    this.enableDisablePrevNextButtons();
    this.calendar.monthSelected.emit(this.calendar.activeDate);
    }
  }

  nextClicked(mode: 'month' | 'year') {
    this.calendar.activeDate = mode === 'month' ?
      this.dateAdapter.addCalendarMonths(this.calendar.activeDate, 1) :
      this.dateAdapter.addCalendarYears(this.calendar.activeDate, 1);
    this.enableDisablePrevNextButtons();
    this.calendar.monthSelected.emit(this.calendar.activeDate);
  }

  private enableDisablePrevNextButtons() {
    this.previousbuttondisabled=((this.today.getMonth())>=(this.dateAdapter.getMonth(this.calendar.activeDate)))&&(
      (this.today.getFullYear())===this.dateAdapter.getYear(this.calendar.activeDate)
     );
  }
}
